import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { useSpace } from "../../../hooks/useSpace";
import { keys } from "./keys";

type UpdatePrivateNoteInput = {
  id: string;
  title: string;
  content: string;
};

export function useUpdatePrivateNote() {
  const queryClient = useQueryClient();
  const { currentSpace } = useSpace();

  return useMutation({
    mutationFn: async (input: UpdatePrivateNoteInput) => {
      const { error } = await apiClient
        .from('private_notes')
        .update({
          title: input.title,
          content: input.content,
        })
        .eq('id', input.id);

      if (error) {
        throw error;
      }
    },
    onSuccess: () => {
      if (currentSpace?.id) {
        queryClient.invalidateQueries({ queryKey: keys.list(currentSpace.id) });
      }
    },
  });
}
